import { CategoryMapDetailPage } from "@/features/channel-category/pages/CategoryMapDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/category-map/$categoryID/detail")({
	component: RouteComponent,
});

function RouteComponent() {
	const { categoryID } = Route.useParams();
	return <CategoryMapDetailPage categoryID={categoryID} />;
}
